import React, { useEffect, useRef } from "react";
import { Form, Modal, Row, Col } from "antd";
import {
  FormHiddenSubmitButton,
  FormSelect,
} from "components/FormItems/FlatFormItems";
import useService from "hooks/useService";
import { useDispatch } from "react-redux";

export default function ServiceAddonsModal({
  visible,
  onCancel,
  isEditModal,
  onSave,

  customer,
  facilityId,
  operationTypeId,
}) {
  const [form] = Form.useForm();
  const submitBtnRef = useRef();
  const dispatch = useDispatch();

  const { products, isFetchingProducts, isFetchingAddons, setProduct, addOns, getFacilityOperationProducts } =
    useService(facilityId, operationTypeId, visible);

  //   const selectedAddOns = Form.useWatch("addOns", form);

  useEffect(() => {
    if (visible === false) {
      form.resetFields();
    } else if (typeof visible === "object") {
      if (visible.productId) {
        getFacilityOperationProducts()
        setProduct(visible.productId);
      }
      const productId = visible.productId;
      const addOns = visible?.addOns?.map?.((addOn) => addOn.productId);
      form.setFieldsValue({
        productId,
        addOns,
      });
    }
  }, [visible]);

  return (
    <Modal
      headerBorder={false}
      width="460px"
      title={`${isEditModal ? "Edit Service" : "Add Service"}`}
      onCancel={onCancel}
      visible={visible}
      onOk={() => submitBtnRef?.current?.click()}
      okText="Save"
      destroyOnClose
    >
      <Form
        requiredMark={false}
        form={form}
        layout="vertical"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          borderBottom: "2px solid #EFF1F4",
          paddingBottom: 12,
        }}
        preserve={false}
        onFinish={async (values) => {
          values.firstName = customer?.firstName;
          values.lastName = customer?.lastName;

          onSave(values);
        }}
        onFinishFailed={({ values, errorFields, outOfDate }) => {
          form.scrollToField(errorFields[0].name, {
            scrollMode: "if-needed",
            block: "center",
            behavior: "smooth",
          });
        }}
      >
        <Row style={{ width: "100%" }}>
          <Col span={24}>
            <FormSelect
              // disabled={isAppointmentFormDisabled}
              variant="underlined"
              name="productId"
              label="Services"
              placeholder="Services"
              required={true}
              formItemStyles={{ marginBottom: 12 }}
              options={products}
              loading={isFetchingProducts}
              renderLabel="productName"
              renderValue="productId"
              onChange={(value) => {
                form.setFieldsValue({
                  addOns: undefined,
                });
                setProduct(value);
              }}
              showSearch={true}
              optionLabelProp="label"
              filterOption={(input, option) => {
                return option?.label
                  ?.toLowerCase?.()
                  .includes?.(input.toLowerCase());
              }}
            />
          </Col>
          {/* TODO: Add rules here as well */}
          <Col span={24}>
            <FormSelect
              // disabled={isAppointmentFormDisabled}
              variant="underlined"
              name="addOns"
              label="Add-ons"
              placeholder="Add-ons"
              // required={true}
              formItemStyles={{ marginBottom: 0 }}
              loading={isFetchingAddons}
              options={addOns}
              renderLabel="productName"
              renderValue="productId"
              mode="multiple"
              optionLabelProp="label"
              filterOption={(input, option) => {
                return option?.label
                  ?.toLowerCase?.()
                  .includes?.(input.toLowerCase());
              }}
            />
          </Col>
        </Row>
        <FormHiddenSubmitButton submitRef={submitBtnRef} />
      </Form>
    </Modal>
  );
}
